module.exports = __webpack_public_path__ + "img/sieckFinesseRelease7.82879bd9.png";